module.exports = __webpack_public_path__ + "img/freefire.b532abd.jpg";